import Memory from '../../service/memory/base/Memory';
import MemoryOperation from '../../service/memory/enum/MemoryOperation';
import MemoryType from '../../service/memory/enum/MemoryType';
import { getFullName } from '../careprovider/visits/utils';

export const getUserDisplayName = () => {
    const memory = new Memory();
    const userData = {};
    userData['key'] = MemoryType.USER;
    const userJson = memory.handleRequest(
        MemoryOperation.READ,
        MemoryType.USER,
        userData
    );
    if (userJson) {
        const displayName = getFullName(userJson?.givenName, userJson?.familyName);
        return displayName;
    }else{
        return "";
    }
};
